<template>
  <card-panel class="referral-status-empty-panel">
    <div slot="content">
      <div>
        <span v-translate="{refereeName: refereeName}">
          %{ refereeName } hasn’t started on any application yet. We will notify you when %{ refereeName } applies for a job.
        </span>
        <div class="file is-centered robot">
          <robot-illustration></robot-illustration>
        </div>
      </div>
    </div>
  </card-panel>
</template>

<script>
import CardPanel from 'top20common/components/card-panel/CardPanel';

import RobotIllustration from 'top20common/components/illustrations/RobotIllustration';

export default {
  props: {
    refereeName: {
      type: String
    }
  },
  components: {CardPanel, RobotIllustration}
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.robot svg {
  max-width: 100%;
  height: auto;
}

@media screen and (max-width: $tablet) {
  .referral-status-empty-panel {
    padding: 10px 0;
    .robot {
      margin: 40px auto 0;
      max-width: 225px;
      max-height: 143px;
    }
  }
}

@media screen and (min-width: $tablet) {
  .referral-status-empty-panel {
    padding: 30px 10px 0;

    .robot {
      margin: 50px auto 30px;
    }
  }
}
</style>
